import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { IconButton, Chip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import dateFormat from "dateformat";
import axios from "axios";
import useDialog from "../../../hooks/useDialog";

//Create component showcasing all payments using only material ui.
export default function PaymentTable({ rows }) {
  const { promptConfirm, showSnackbar } = useDialog();

  const handleDeletePayment = async (paymentId) => {
    const confirmed = await promptConfirm({
      title: "დადასტურება",
      message: "დარწმუნებული ხართ, რომ გსურთ გადახდის წაშლა?",
    });

    if (!confirmed) {
      return;
    }

    try {
      const response = await axios.delete(`/agency/delete_payment/${paymentId}`);
      showSnackbar(response.data.message, "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      if (err.response?.data?.message) {
        showSnackbar(err.response.data.message, "error");
      } else {
        showSnackbar("დაფიქსირდა შეცდომა", "error");
      }
    }
  };
  const columns = [
    {
      field: "bank",
      headerName: "ბანკი",
      flex: 2,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return params.row.bank.name;
      },
    },
    { field: "actual_amount", headerName: "რეალურად გადარიცხული თანხა", flex: 2, headerAlign: "center", align: "center" },
    { field: "calculated_amount", headerName: "სოფტის მიერ გამოთვლილი თანხა", flex: 2, headerAlign: "center", align: "center" },
    {
      field: "payment_date",
      headerName: "გადახდის თარიღი",
      flex: 2,
      headerAlign: "center",
      align: "center",
      type: "date",
      valueGetter: (params) => {
        return dateFormat(params.row.payment_date, "yyyy-mm-dd", true);
      },
    },
    {
      field: "upload_date",
      headerName: "ატვირთვის თარიღი",
      flex: 2,
      headerAlign: "center",
      align: "center",
      type: "date",
      valueGetter: (params) => {
        return dateFormat(params.row.upload_date, "yyyy-mm-dd");
      },
    },
    {
      field: "comment",
      headerName: "კომენტარი",
      flex: 2,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return params.row.comment || "-";
      },
    },
    {
      field: "status",
      headerName: "სტატუსი",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return params.row.is_deleted ? "წაშლილი" : "აქტიური";
      },
      renderCell: (params) => {
        if (params.row.is_deleted) {
          return <Chip label="წაშლილი" color="error" variant="outlined" size="small" />;
        }
        return <Chip label="აქტიური" color="success" variant="outlined" size="small" />;
      },
    },
    // Only show actions column if user has MODIFY_SCHEDULING permission and is AGENCY role
    JSON.parse(localStorage.getItem("permissions"))?.includes("MODIFY_SCHEDULING") &&
      localStorage.getItem("role") === "ROLE_AGENCY" && {
        field: "actions",
        headerName: "მოქმედებები",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (params) => {
          if (params.row.is_deleted) {
            return null;
          }
          return (
            <IconButton color="error" size="small" onClick={() => handleDeletePayment(params.row._id)} title="გადახდის წაშლა">
              <ClearIcon />
            </IconButton>
          );
        },
      },
  ];

  return (
    <div style={{ marginTop: 30, height: 400, width: "100%" }}>
      <DataGrid
        getRowId={(row) => row._id}
        rows={rows}
        columns={columns}
        pageSize={100}
        rowsPerPageOptions={[5, 20, 50, 100]}
        disableColumnMenu={false}
        initialState={{
          filter: {
            filterModel: {
              items: [
                {
                  columnField: "status",
                  operatorValue: "equals",
                  value: "აქტიური",
                },
              ],
            },
          },
        }}
        components={{
          Toolbar: GridToolbar,
        }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
    </div>
  );
}
